import { render, staticRenderFns } from "./ArtistSelect.vue?vue&type=template&id=403dea52&"
import script from "./ArtistSelect.vue?vue&type=script&lang=js&"
export * from "./ArtistSelect.vue?vue&type=script&lang=js&"
import style0 from "./ArtistSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports